import { render, staticRenderFns } from "./MetaBox.vue?vue&type=template&id=17734aed&"
import script from "./MetaBox.vue?vue&type=script&lang=js&"
export * from "./MetaBox.vue?vue&type=script&lang=js&"
import style0 from "./MetaBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MetaBox.vue"
export default component.exports